import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDrop: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconDrop"><Path d="M19.25 14.0556C19.25 18.029 16.0041 21.25 12 21.25C7.99594 21.25 4.75 18.029 4.75 14.0556C4.75 9.90093 8.66637 5.38435 10.7422 3.28215C11.4445 2.57099 12.5555 2.57099 13.2578 3.28216C15.3336 5.38435 19.25 9.90093 19.25 14.0556Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconDrop;
